import axios from "axios";
import { useEffect, useState } from "react";
import moment from "moment";

export const NewsletterEmailList = () => {
  const [emailList, setEmailList] = useState([]);
  useEffect(() => {
    const fetchEmailList = async () => {
      try {
        const response = await axios.get(
          `https://api.bgmhotel.com/cosumerEmailList`
        );
        setEmailList(response.data.data);
        // console.log("response", response.data.data);
      } catch (err) {
        console.log(
          err.response?.data?.message || "Failed to fetch email list."
        );
      }
    };

    fetchEmailList();
  }, []); // Empty dependency array ensures this runs only once

  return (
    <>
      <div className="accordion-item inquiryStyle">
        <h2 className="accordion-header">
          <button
            className="accordion-button accordion-email collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseFour"
            aria-expanded="false"
            aria-controls="collapseFour"
          >
            Newsletter Email Registered User
          </button>
        </h2>
        <div
          id="collapseFour"
          className="accordion-collapse collapse"
          data-bs-parent="#adminPanelRoomDetail"
        >
          <div className="accordion-body">
            <div className="col-12 mt-5 amenities">
              <h6>Newsletter Registered User</h6>

              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead className="table-dark">
                    <tr>
                      <th className="text-center">Sr. No</th>
                      <th>Register Date</th>
                      <th>Email</th>
                    </tr>
                  </thead>
                  <tbody>
                    {emailList.map((email, index) => (
                      <tr key={email._id}>
                        <td className="text-center">{index + 1}</td>
                        {/* <td>{email?.createdAt}</td> */}
                        <td>{moment(email?.createdAt).format("YYYY-MM-DD")}</td>
                        <td>{email?.email}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
